import styled from 'styled-components';

// ANIMATIONS
import { SlideLeftKeyframe, SlideRightKeyframe } from './animations';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

// ENUMS
import { Alignments } from '../../enums/alignments';

// INTERFACES
import { ISliderOverlay } from '../../interfaces/SliderOverlay.interface';

export const Container = styled.section<ISliderOverlay>`
  position: fixed;
  top: 0;
  width: 100vw;
  right: 0;
  height: 100vh;
  z-index: 10001;
  background-color: rgba(0, 0, 0, 0.5);
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  display: flex;
  justify-content: flex-end;
`;

export const SliderContainer = styled.div<ISliderOverlay>`
  position: relative;
  animation: ${({ isVisible }) => isVisible && SlideRightKeyframe} 600ms ease-out;
  display: flex;
  background-color: ${theme.colors.primary.white};
  flex-flow: column nowrap;
  height: 100vh;
  width: ${({ fullScreen }) => (fullScreen ? '100vw' : '753px')};
  z-index: 10002;
  padding: 102px 80px 26px 80px;
  overflow-y: scroll;

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    padding: 58px 8px 0 24px;
  }
`;

export const CloseButton = styled.div<ISliderOverlay>`
  position: absolute;
  top: 40px;
  right: 40px;
  ${({ alignment }) =>
    alignment === Alignments.RIGHT &&
    `
    right: 40px;
  `}
  ${({ alignment }) =>
    alignment === Alignments.LEFT &&
    `
    left: 40px;
  `}
  width: 40px;
  height: 40px;
  padding: 8px;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  border-radius: 8px;
  display: flex;
  justify-items: center;
  align-items: center;
  place-content: center center;
  cursor: pointer;

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    top: 16px;

    ${({ alignment }) =>
      alignment === Alignments.RIGHT &&
      `
    right: 9px;
  `}
    ${({ alignment }) =>
      alignment === Alignments.LEFT &&
      `
    left: 9px;
  `}
  }
`;
